// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module--footer--1M7a8","logoHolder":"Footer-module--logoHolder--3NXIm"};